module.exports = __webpack_public_path__ + "files/3a7502c0013fcbd1f93e78df5ab4f5d3.png";